import type { PrivilegesApiResponse } from '../model/interfaces'

import { useAdminRoutes } from '@shared/lib/routes'

import { useProfileStore } from '../model/store'

export const usePrivilegesApi = async (): Promise<string[] | null> => {
  const { $axios } = useNuxtApp()
  const profileStore = useProfileStore()

  const url = useAdminRoutes('admin.privileges')
  if (!url) {
    profileStore.setPrivileges(null)
    return null
  }

  try {
    const { data } = await $axios.get<PrivilegesApiResponse>(url)
    profileStore.setPrivileges(data.data.privileges)
    return data.data.privileges
  } catch (err: unknown) {
    console.error(err)
    return null
  }
}
